import React from 'react';
import { Container, Row } from '@vfpf/vfpf-shared';

const EherkenningRow: React.FC = () => {
  return (
    <Row>
      <div className="col-lg-16 offset-lg-2">
        <ul className="nav flex-column flex-sm-row">
          <div className="col-lg-19">
            <small>
              {
                'Meer zekerheid over uw online identiteit, daarom gebruiken wij eHerkenning. Met eHerkenning identificeert u zich veilig en eenvoudig online. Het grote gemak is dat u met eHerkenning bij meerdere organisaties kunt inloggen. U hoeft dus minder wachtwoorden te onthouden. Veilig, makkelijk en betrouwbaar. Ga voor meer informatie naar '
              }
              <a
                href={`https://www.eherkenning.nl/`}
                className="font-weight-semi-bold"
                target="_blank"
                rel="noreferrer"
              >
                www.eherkenning.nl
                <span className="sr-only">(opent externe website)</span>
              </a>
              .
            </small>
          </div>
          <div className="col-lg-5 mt-3">
            <a className="navbar-brand" href="https://www.eherkenning.nl/">
              <img src={'./assets/img/Eherkenning.svg'} width="159" height="48" alt="Logo eherkenning" />
            </a>
          </div>
        </ul>
      </div>
    </Row>
  );
};

const CopyrightRow: React.FC = () => {
  return (
    <Row>
      <div className="col-lg-16 offset-lg-2 mt-2 mb-2">
        <div className="ssa-footer">
          <ul className="nav flex-column flex-sm-row">
            <div className="col-lg-6">
              <li className="ssa-footer-title">
                <small className="ssa-footer-body">
                  Meer informatie over Subsidie Sluitende Aanpak en het pre-advies vindt u op onze website:
                  <br />
                  <u>
                    <a href="https://www.vfpf.nl/subsidie-sluitende-aanpak" target="_blank">
                      {' '}
                      vfpf.nl{' '}
                    </a>
                  </u>
                </small>
              </li>
            </div>
            <div className="ssa-footer-rectangle-div-alt">
              {' '}
              <div className="ssa-footer-rectangle"></div>{' '}
            </div>
            <div className="col-lg-7">
              <li className="ssa-footer-title">
                {' '}
                VfPf – afdeling Casemanagement
                <br />
                <small className="ssa-footer-body">
                  <a href={'tel: 0888373030'}> 088 - 837 30 30 (keuze 1)</a>
                  <br />
                  <a href={'mailto: casemanagement@vfpf.nl'}> casemanagement@vfpf.nl </a>
                </small>
              </li>
            </div>
            <div className="ssa-footer-rectangle-div-alt">
              {' '}
              <div className="ssa-footer-rectangle"></div>{' '}
            </div>
            <div className="text-lg-right col-10">
              <a href="https://www.vfpf.nl/" target="_blank" rel="noreferrer">
                <li className="ssa-footer-copyright"> © Vervangingsfonds & Participatiefonds </li>
              </a>
            </div>
          </ul>
        </div>
      </div>
    </Row>
  );
};

export const LoginFooterSSA: React.FC = () => {
  return (
    <footer className="footer-alt">
      <Container>
        <CopyrightRow />
        <EherkenningRow />
      </Container>
    </footer>
  );
};
